import { angleFromPoint, polarToCartesian } from './functions';

export const glslSpiralVortex = /*glsl*/ `
    ${polarToCartesian}
    ${angleFromPoint}

    // Spiral warp: twist the noise texture around the center
    float spiralWarpedNoise(
        sampler2D noiseMap,
        vec2 uv,
        float noiseScale,
        float time,
        float twistAmount, // how much to twist at the edge (e.g. 4.0 * PI)
        float noiseOffset // how much to offset the noise (e.g. 0.5)
    ) {
        // Center UV
        vec2 p = uv - 0.5;
        float r = length(p);
        r *= noiseScale;
        float angle = angleFromPoint(p);

        // Amount of twist increases with radius
        float maxTwist = twistAmount; // e.g. 4.0 * PI for 2 full turns at edge
        float twist = maxTwist * pow(r, 0.5);

        // Animate the twist (optional)
        twist += time;

        // Apply the twist to the angle
        float twistedTheta = angle + twist;

        // Convert back to cartesian for noise lookup
        vec2 warped = polarToCartesian(r + noiseOffset, twistedTheta);

        // pulls the noise towards the center, not sure how 🤷🏼‍♀️
        float pull = time * 0.05;
        if (fract(warped.x) > 0.5) warped.x += pull;
        else warped.x -= pull;

        // Sample the noise texture at the warped coordinates
        float n = texture2D(noiseMap, warped).r;

        return n;
    }
`;
